import React from 'react'

/**
 * Display or not if exist in channels
 * @param {React.Component} WrappedComponent
 * @param {string[]} allowedChannels Array of channels
 *
 * @returns {React.Component}
 */
function withChannels(WrappedComponent, allowedChannels = []) {
  function DisplayForChannel(props) {
    const { channel } = props
    if (!allowedChannels.includes(channel)) return null

    return <WrappedComponent {...props} />
  }

  return DisplayForChannel
}

export default withChannels